export const styles = {
    bold: {
        fontWeight: 500
    },
    addButton: {
        marginLeft: -5
    }
};
